import { FlowType } from "@redotech/redo-model/return-flow";
import { ReturnOptionMethod } from "@redotech/redo-model/return-flow/return-option";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import {
  ReturnMethodState,
  getLabelForReturnOption,
} from "@redotech/redo-return-ui/flows/return-flow/condition-types/return-method";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { memo, useMemo } from "react";

export const ReturnMethodDetails = memo(function ReturnMethodDetails({
  state,
  setState,
  disabled,
  flowType,
}: ConditionTypeDetailsProps<ReturnMethodState>) {
  const returnMethodOptions: RedoListItem<ReturnOptionMethod["type"]>[] =
    useMemo(
      () =>
        (
          [
            ReturnOptionMethod.EXCHANGE,
            ReturnOptionMethod.REFUND,
            ReturnOptionMethod.STORE_CREDIT,
          ] as const
        ).map((method) => ({
          id: method,
          value: method,
          type: "text" as const,
          text: getLabelForReturnOption(method),
        })),
      [],
    );

  const selectedMethod = state.returnMethod
    ? returnMethodOptions.find((option) => option.value === state.returnMethod)
    : undefined;

  return (
    <RedoSingleSelectDropdownInput
      description={
        flowType === FlowType.FINALIZE_CLAIM
          ? "Condition will match if any selected items have this compensation method"
          : undefined
      }
      disabled={disabled}
      flexGrow
      label={
        flowType === FlowType.FINALIZE_CLAIM
          ? "Compensation method"
          : "Return method"
      }
      options={returnMethodOptions}
      optionSelected={({ item }) =>
        setState({ ...state, returnMethod: item.value })
      }
      placeholder="Select method..."
      selectedItem={selectedMethod}
      size="xs"
    />
  );
});
